export default function XSLT_Choose() {
  return (
    <div>
      <h1>XSLT_Choose</h1>
      <p>This is the XSLT_Choose component.</p>
    </div>
  );
}